const padding = number => {
  if (number < 100 && number < 10) {
    return `00${number}`
  } else if (number < 100) {
    return `0${number}`
  } else {
    return `${number}`
  }
}

const fit = (container, attempts = 30) => {
  let resizeText = el => {
    attempts--
    let elNewFontSize
    if (el.style.fontSize === '' || el.style.fontSize === 'inherit' || el.style.fontSize === 'NaN') {
      elNewFontSize = '22px' // largest font to start with
    } else {
      elNewFontSize = parseInt(el.style.fontSize.slice(0, -2), 10) - 1 + 'px'
    }
    el.style.fontSize = elNewFontSize

    // this function can crash the app, so we need to limit it
    if (attempts <= 0) {
      return
    }

    if (el.scrollHeight > el.offsetHeight) {
      resizeText(el)
    }
  }

  resizeText(container)
}

export { padding, fit }



// WEBPACK FOOTER //
// ./src/utils/index.js